<template>
  <div class="attachment">
    <template v-if="this.hasImagePreview">
      <a :href="this.downloadUrl" target="_blank">
        <div class="preview-holder">

          <img class="preview" :src="this.downloadUrl" />
        </div>
      </a>
    </template>

    <template v-else-if="this.hasAudioPreview">
      <div class="preview-holder">
        <audio controls :src="this.downloadUrl"></audio>
      </div>
    </template>
    <template v-else-if="this.hasVideoPreview">
      <div class="preview-holder">

        <video width="400" controls>
          <source :src="this.downloadUrl">
          Your browser does not support HTML video.
        </video>
      </div>
    </template>

    <template v-else>
      <a :href="this.downloadUrl" target="_blank">
        <div class="download-link">
          <TickIcon name="file" /> {{ this.attachmentLink.name }}
        </div>
      </a>

    </template>

  </div>
</template>

<script lang="ts">

import { AttachmentLink, } from "@/TickApi";
import { Component, Prop } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";
import TickIcon from "@/components/atoms/TickIcon.ce.vue";

@Component({
  emits: [],
  components: { TickIcon },
})
export default class Attachment extends Vue {
  @Prop() private attachmentLink!: AttachmentLink;


  private get downloadUrl() {
    return this.attachmentLink.url;
  }

  private get hasImagePreview() {
    return this.hasPreview(["jpeg", "jpg", "gif", "bmp", "png"]);
  }

  private get hasAudioPreview() {
    return this.hasPreview(["ogg", "oga", "mpeg", "mp3"]);
  }

  private get hasVideoPreview() {
    return this.hasPreview(["avi", "wmv", "mov", "mp4", "webm"]);
  }

  private hasPreview(formats: string[]): boolean {
    const extension = this.attachmentLink.name.split('.').pop().toLowerCase();

    if (formats.some(p => p == extension)) {
      return true;
    } else {
      return false;
    }

  }

}
</script>

<style lang="scss" scoped>
@import "@/styles/theme";

.attachment {

  .download-link {
    background: var(--cw-conversation-message-outbound-bg-color);
    color: var(--cw-conversation-message-outbound-fg-color);
    border: solid var(--cw-conversation-message-outbound-border-width) var(--cw-conversation-message-outbound-border-color);
    border-radius: var(--cw-conversation-message-outbound-border-radius);


    display: inline-flex;
    padding: 5px;
    cursor: pointer;

    svg {
      margin-right: 5px;
    }
  }

  .preview-holder {
    border-radius: var(--cw-conversation-message-outbound-border-radius);
    overflow: hidden;

    .preview {
      //border-radius: 6px;
      max-height: 100%;
      max-width: 100%;
    }

    // audio::-webkit-media-controls-panel {
    //   background-color: #56AEFF;
    // }



  }
}
</style>